var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderContentModeSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6563 5.88365H14.9629C14.7383 5.88372 14.5229 5.79453 14.3641 5.63573C14.2053 5.47693 14.1162 5.26153 14.1162 5.03695V3.34353C14.1162 3.11895 14.2053 2.90355 14.3641 2.74475C14.5229 2.58595 14.7383 2.49676 14.9629 2.49683H16.6563C16.8809 2.49676 17.0963 2.58595 17.2551 2.74475C17.4139 2.90355 17.5031 3.11895 17.503 3.34353V5.03695C17.5031 5.26153 17.4139 5.47693 17.2551 5.63573C17.0963 5.79453 16.8809 5.88372 16.6563 5.88365Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1163 4.19028H6.66528",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8097 13.3412V5.89014",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8113 14.937H7.12368L4.72852 17.282C4.48859 17.5169 4.13122 17.5851 3.82163 17.4551C3.51205 17.325 3.31059 17.0221 3.31042 16.6863V7.51954C3.31057 7.18307 3.51281 6.87963 3.82329 6.74999C4.13378 6.62035 4.49175 6.68989 4.73112 6.92635L11.3977 13.5099C11.6383 13.7476 11.7115 14.1072 11.583 14.4201C11.4544 14.733 11.1496 14.9372 10.8113 14.937V14.937Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderContentModeSettings);
export default ForwardRef;